var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "152px",
    height: "20px",
    viewBox: "0 0 457 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#8e8e8e",
    fillOpacity: 1,
    cx: -31,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#a4a4a4",
    fillOpacity: 0.8,
    cx: -97,
    cy: 30,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#bababa",
    fillOpacity: 0.61,
    cx: -163,
    cy: 30,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#e7e7e7",
    fillOpacity: 0.22,
    cx: -229.5,
    cy: 30.5,
    r: 13.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#f2f2f2",
    fillOpacity: 0.12,
    cx: -295,
    cy: 31,
    r: 11
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "61 0;127 0;193 0;259 0;325 0;391 0;457 0;523 0;589 0;655 0;721 0;787 0;0 0;0 0;0 0;0 0;0 0;0 0;0 0;0 0;0 0;0 0;0 0;",
    calcMode: "discrete",
    dur: "1920ms",
    repeatCount: "indefinite"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#8e8e8e",
    fillOpacity: 1,
    cx: 488,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#a4a4a4",
    fillOpacity: 0.8,
    cx: 554,
    cy: 30,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#bababa",
    fillOpacity: 0.61,
    cx: 620,
    cy: 30,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#e7e7e7",
    fillOpacity: 0.22,
    cx: 686.5,
    cy: 30.5,
    r: 13.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#f2f2f2",
    fillOpacity: 0.12,
    cx: 753,
    cy: 31,
    r: 11
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 0;0 0;0 0;0 0;0 0;0 0;0 0;0 0;0 0;0 0;0 0;-61 0;-127 0;-193 0;-259 0;-325 0;-391 0;-457 0;-523 0;-589 0;-655 0;-721 0;-787 0;",
    calcMode: "discrete",
    dur: "1920ms",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.12b0ed9e16e036e01e5d70c9b10084e8.svg";
export { ForwardRef as ReactComponent };